import React from 'react';
import { stats, statsTitle } from '../data/content';
export function ProofBar() {
  return <section className="w-full bg-gray-50 py-14 md:py-20" data-id="element-194" data-mp="mai1uus3dama">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-195" data-mp="mc1gyi20hfmh">
        <h2 className="mx-auto max-w-3xl text-center text-2xl font-extrabold leading-tight tracking-tight text-gray-900 md:text-3xl" data-id="element-196" data-mp="7k0y34rzi8m8">
          {statsTitle}
        </h2>

        <dl className="mt-10 grid grid-cols-2 gap-8 border-t border-gray-200 pt-10 text-center sm:grid-cols-3 lg:grid-cols-6" data-id="element-197" data-mp="3up8sn50u6pp0">
          {stats.map(stat => <div key={stat.label} data-id="element-198" data-mp="3he693vbcnp1">
              <dt className="sr-only" data-id="element-199" data-mp="3ks444yjiqi51">{stat.label}</dt>
              <dd data-id="element-200" data-mp="3ktf5ystelfti">
                <span className="block text-4xl font-extrabold tracking-tight text-gray-900 md:text-5xl" data-id="element-201" data-mp="3ktyn47b8c06h">
                  {stat.value}
                </span>
                <span className="mx-auto mt-1 block max-w-[14rem] text-sm font-semibold text-blue-700" data-id="element-202" data-mp="1j1itngzew1xo">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}